"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTriggerRegistration = useTriggerRegistration;
var _formatErrorMessage2 = _interopRequireDefault(require("@base-ui-components/utils/formatErrorMessage"));
var React = _interopRequireWildcard(require("react"));
/**
 * Returns a callback ref that registers/unregisters the trigger element in the store.
 *
 * @param id ID of the trigger. This must not be undefined by the time a ref is assigned.
 * @param store The Store instance where the trigger should be registered.
 */
function useTriggerRegistration(id, store) {
  const registeredIdRef = React.useRef(null);
  return React.useCallback(triggerElement => {
    if (id == null) {
      throw new Error(process.env.NODE_ENV !== "production" ? 'Base UI: Trigger must have an `id` prop specified.' : (0, _formatErrorMessage2.default)(77));
    }
    const triggers = new Map(store.state.triggers);
    if (triggerElement != null) {
      triggers.set(id, triggerElement);
      // Keeping track of the registered id in case it changes.
      registeredIdRef.current = id;
    } else if (registeredIdRef.current != null) {
      triggers.delete(registeredIdRef.current);
      registeredIdRef.current = null;
    }
    store.set('triggers', triggers);
  }, [store, id]);
}